import React from 'react';
import type { DashboardFetcher, WidgetDefinition } from './types';
import type { WidgetAccessAdapter } from './access/types';
import { DashboardContext } from './useDashboardContext';

/**
 * Provider del tablero: inyecta el fetcher del host y el catálogo de widgets.
 *
 * El contexto y su hook de lectura viven en `useDashboardContext.ts` — ver el porqué allí.
 * Este módulo exporta SOLO el componente, que es lo que `react-refresh` necesita.
 */
export const DashboardProvider: React.FC<{
  fetcher: DashboardFetcher;
  catalog?: WidgetDefinition[];
  /** Ver `DashboardContextValue.accessAdapter`. Sin él no se pinta ningún control de acceso. */
  accessAdapter?: WidgetAccessAdapter;
  children: React.ReactNode;
}> = ({ fetcher, catalog, accessAdapter, children }) => (
  <DashboardContext.Provider value={{ fetcher, catalog, accessAdapter }}>
    {children}
  </DashboardContext.Provider>
);
